export default {
    setUnauthPageContents (state, {coll}) {
        state.unauthPageContents = coll
    },
    setAllContents (state, {coll}) {
        state.allContents = coll
    },
    setAllNewsResources (state, {coll}) {
        state.newsResources = coll
    },
    setFAResources (state, {coll}) {
        state.faResources = coll
    },
    setSTResources (state, {coll}) {
        state.stResources = coll
    },
    setABResources (state, {coll}) {
        state.abResources = coll
    }
}



// WEBPACK FOOTER //
// ./src/store/dynamiccontents/mutations.js